import React from 'react';
import { styled } from '@ff/ui';
import Box from '@ff/ui/Box';
import { createUseStyles } from 'react-jss';
import PlaylistItem from './PlaylistItem'

export default function Playlist(props) {
  const { list = [], onSelect, currentPlayingItem, region, hideMobilePlaylist } = props;
  const c = useStyles(props);

  return (
    <Container hideOnMobile={hideMobilePlaylist}>
      <div className={c.absolute}>
        <div className={c.content}>
          {
            list.map((item, index) => (
              <PlaylistItem
                key={item.source}
                region={region}
                data={item}
                isPlaying={currentPlayingItem === index}
                onClick={() => onSelect(index, item)}
              />
            ))
          }
        </div>
      </div>
    </Container>
  );
}

// container height will fit sibling's
export const Container = styled(Box)(({ hideOnMobile }) => ({
  position: 'relative',
  overflowY: 'auto',
  overflowX: 'hidden',
  flex: 1,

  '@media(max-width: 960px)': {
    width: '100%',
    display: hideOnMobile ? 'none' : 'block',
  },

  '::-webkit-scrollbar': {
    width: '2px',
  },
  '::-webkit-scrollbar-thumb': {
    background: 'rgba(255, 255, 255, 0.4)',
  },
  '::-webkit-scrollbar-track': {
    backgroundColor: 'rgba(255, 255, 255, 0.15)',
  },
}));

const useStyles = createUseStyles({
  // absolute container prevents pushing parent container height over its sibling's height
  absolute: {
    position: 'absolute',
    left: 0,
    width: '100%',

    '@media(max-width: 960px)': {
      position: 'relative',
      right: 'initial'
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',

    '@media(max-width: 960px)': {
      marginTop: 16,
      maxHeight: 774,
    }
  },
});
